import { Headers } from 'cross-fetch';
import { StringService } from '../string';
import { HistoryService } from '@rocheglobal/component-library-dot-com/src/services/history';
import { DatalayerItem, TrackingService } from '@rocheglobal/component-library-dot-com/src/services/tracking';

export const getFileName = (url: string) => url.substring(url.lastIndexOf('/') + 1);

export const downloadFile = async (url: string, myHeaders) =>
  fetch(`${url}`, {
    method: 'GET',
    mode: 'cors',
    cache: 'no-cache',
    headers: myHeaders,
  });

export const DownloadService = {
  get defaultTracking(): DatalayerItem {
    return {
      event: 'download',
      component_name: 'roche-download-teaser',
    };
  },

  async handleDownload(url: string) {
    const myHeaders = new Headers({ Origin: HistoryService?.getActiveUrl()?.origin });
    const fileName = getFileName(url);
    const response = await downloadFile(url, myHeaders);

    if (response.status !== 200) {
      return;
    }

    const blob = await response.blob();
    const contentType = response.headers.get('content-type');
    let fileUrl = url;

    if (contentType !== 'application/pdf') {
      fileUrl = URL.createObjectURL(blob);
    }
    const fileLink = this.addLinkElement(fileUrl, fileName, contentType);

    this.trackDownloadLinkClick(fileName);
    fileLink.click();
    fileLink.remove();
  },
  addLinkElement(url: string, filename: string, contentType: string) {
    const fileLink = document.createElement('a');
    fileLink.href = url;
    fileLink.download = filename;
    fileLink.setAttribute('skipOnClickNotice', '');
    if (contentType === 'application/pdf') {
      fileLink.setAttribute('target', '_blank');
    }
    document.body.appendChild(fileLink);
    return fileLink;
  },

  trackDownloadLinkClick(fileName: string): void {
    TrackingService.push({
      ...this.defaultTracking,
      additionalParameters: {
        file_type: StringService.getExtension(fileName),
      },
      value: fileName,
    });
  },
};

export interface DownloadTriggerEvent {
  url: string;
}
